import React from 'react';

function DoorlyLogo({ size = 36, className = '' }) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/favicon-light.png`}
      width={size}
      height={size}
      alt="Doorly logo"
      className={className}
      style={{ objectFit: 'contain', display: 'block' }}
    />
  );
}

export default DoorlyLogo;
